import { cn } from "@lib/cn"
import type { HTMLAttributes } from "react"

/**
 * The one card shell (PRD-59). Before this, 35 sites hand-rolled a card with
 * four different radii and three different border colours; `Card` itself had
 * only 7 importers. Roles, not palette steps: a component that writes
 * `dark:bg-slate-900` on a card is bypassing the token layer.
 *
 * Cards do not nest. A panel inside a card is an `inset` — see `StatTile`'s
 * variant and the `Inset` export below.
 */
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("rounded-card border-border bg-surface shadow-raised border", className)}
      {...props}
    />
  )
}

/** A sunken region INSIDE a card. The answer to "I need a card in a card". */
export function Inset({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("rounded-control bg-inset", className)} {...props} />
}

export function CardHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("border-hairline border-b p-4", className)} {...props} />
}

export function CardBody({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("p-4", className)} {...props} />
}

export function CardFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("border-hairline border-t p-4", className)} {...props} />
}
